module.exports = __webpack_public_path__ + "static/media/img-grow-thumb@3x.c86174f1.png";